import { Command } from 'pos/common';
import { Result, handleServerErrors, PrintError, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res } from 'core/api';
import { PrintFacade } from 'pos/facades';
import * as Images from 'pos/Images';
import ShowPreviewScreen from 'pos/ui/ShowPreviewScreen';
import { Message, Modal } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		printTotalBalance: () => Promise<Result>
	}
}

Command.register('printTotalBalance', Preconditions.ensure(Permission.Pos_PrintTotalBalanceReport), async (): Promise<Result> => {

	return await Modal.show(ShowPreviewScreen,
		{
			title: Res.Web.TOTAL_BALANCE_REPORT_PREVIEW(),
			image: Images.PrintTotalBalance,
			preview: await PrintFacade.getTotalBalancePreview(),
			onPrint: async () => {

				if (SessionProvider.isSlave()) {
					await Message.show(Res.Msg.MSG_OPERATION_ONLY_VALID_IN_MASTER_POS());
					return Result.error();
				}

				await handleServerErrors(() => PrintFacade.printTotalBalance(), {
					onPrintError: async (error: PrintError) => { await Message.show(error.message); }
				});

				return Result.ok();
			}
		});
});